var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_"},[_c('div',{staticClass:"box_"},[_c('div',{staticClass:"box_i"},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":""}})]),_c('div',{staticClass:"box_i box_i_center"},[_c('p',[_vm._v(_vm._s(_vm.servicePhone))]),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"phone_"}),_vm._v("全国统一客服热线")])
}]

export { render, staticRenderFns }